import React from 'react';
import { Download } from '../Download';

type ConfigFile = { extension: string; url: string; name: string };
type DownloadableConfigurationFilesProps = {
  files: ConfigFile[];
};

export function DownloadableConfigurationFiles({ files }: DownloadableConfigurationFilesProps) {
  return (
    <>
      {files.map(file => (
        <div className="configuration-file-upload__default-view" key={file.url}>
          <Download
            url={file.url}
            fileName={file.name}
            fileExtension={file.extension}
            mimeType={`text/${file.extension}`}
            fileSizeBytes={1024}
          />
        </div>
      ))}
    </>
  );
}
